"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentAudioLocalComponentParameters = void 0;
exports.SegmentAudioLocalComponentParameters = [
    {
        id: 'recording',
        label: 'Audio File',
        description: 'Input Param - Audio File To Segment',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'segments',
        label: 'Generated Audio Segments',
        description: 'Input Param - Generated Audio Segments',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
];
//# sourceMappingURL=SegmentAudioLocal.js.map